import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

const expandedWidth = 292;
const collapsedWidth = 96;

export default styled(Drawer)(({ theme, ownerState }) => {
  const { breakpoints, transitions } = theme;
  const { miniSidenav, isMobile } = ownerState;

  const sharedPaperStyles = {
    border: "none",
    overflowX: "hidden",
    boxShadow: "0 26px 68px rgba(0, 0, 0, 0.42)",
    background:
      "radial-gradient(circle at top left, rgba(94,168,255,0.16) 0%, rgba(12,22,38,0) 28%), linear-gradient(180deg, rgba(9,18,31,0.99) 0%, rgba(6,13,23,0.99) 100%)",
    color: "#fff",
    backdropFilter: "blur(20px)",
    transition: transitions.create("width", {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),
  };

  return {
    width: isMobile ? expandedWidth : miniSidenav ? collapsedWidth : expandedWidth,
    flexShrink: 0,
    "& .MuiDrawer-paper": {
      ...sharedPaperStyles,
      width: isMobile ? expandedWidth : miniSidenav ? collapsedWidth : expandedWidth,
      padding: theme.spacing(1.5),
      borderRight: "1px solid rgba(126, 170, 220, 0.12)",
      [breakpoints.down("xl")]: {
        width: expandedWidth,
        padding: theme.spacing(1.25),
      },
    },
  };
});
